function Skills() {
  return (
    <div className="background_color_blue">
      <section className="skills">
        <h2 className="section-title skills__title">Skills</h2>
        <ul className="skills__container">
          <li className="skills__item">HTML5</li>
          <li className="skills__item">CSS3</li>
          <li className="skills__item">JavaScript</li>
          <li className="skills__item">TypeScript</li>
          <li className="skills__item">React</li>
          <li className="skills__item">Redux</li>
          <li className="skills__item">Jest</li>
          <li className="skills__item">React Testing Library</li>
          <li className="skills__item">Node.js</li>
          <li className="skills__item">Express</li>
          <li className="skills__item">MongoDB</li>
          <li className="skills__item">REST API</li>
          <li className="skills__item">ESLint</li>
          <li className="skills__item">Postman</li>
          <li className="skills__item">Git</li>
          <li className="skills__item">GitHub</li>
          <li className="skills__item">GitHub Actions</li>
          <li className="skills__item">Docker</li>
          <li className="skills__item">Nginx</li>
          <li className="skills__item">AWS</li>
          <li className="skills__item">Vite</li>
          <li className="skills__item">Adobe Illustrator</li>
          <li className="skills__item">Adobe Photoshop</li>
          <li className="skills__item">Figma</li>
          <li className="skills__item">English</li>
          <li className="skills__item">German</li>
          <li className="skills__item">Russian</li>
        </ul>
      </section>
    </div>
  );
}

export default Skills;
